import ListBonDocuments from "./ListBonDocuments";

const ListBonSortie = () => (
  <ListBonDocuments
    transactionType={1}
    title="Bons de sortie"
    icon="fa-dolly"
    subtitle="Consultez les bons de sortie d'un dépôt sur une période"
    singular="bon de sortie"
    plural="bons de sortie"
  />
);
export default ListBonSortie;
